import "./src/assets/fonts/fonts.css"
import wrapWithProvider from "./wrap-with-provider"
export const wrapRootElement = wrapWithProvider